<template>
  <v-list id="menu-options" dense class="py-0">
    <template v-for="item in getMenuOptions">
      <template v-if="item.items.length == 0">
        <v-list-item :key="item.title" link :to="item.path" class="my-1">
          <v-list-item-icon>
            <v-icon small>
              {{ item.icon }}
            </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-else>
        <v-list-group :key="item.title">
          <template #appendIcon>
            <v-icon small> fas fa-chevron-down </v-icon>
          </template>
          <template #activator>
            <v-list-item-icon>
              <v-icon small>
                {{ item.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="(child, i) in item.items" :key="child.path" link :to="child.path" class="pr-0">
            <v-list-item-content v-if="!child.items || !child.items.length">
              <v-list-item-title>
                {{ child.title }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-content v-else>
              <v-list id="menu-sub-options" dense class="py-0">
                <v-list-group :key="`${child.title}-${i}`" prepend-icon="" no-action sub-group class="ml-0">
                  <template #appendIcon>
                    <v-icon small class="mr-2"> fas fa-chevron-down </v-icon>
                  </template>
                  <template #activator>
                    <v-list-item-content>
                      <v-list-item-title>{{ child.title }}</v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item
                    v-for="subchild in child.items"
                    id="items-sub-options"
                    :key="subchild.path"
                    :to="subchild.path"
                    link
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ subchild.title }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </v-list>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </template>
    </template>

    <v-list-item>
      <v-btn href="https://beta.wegrou.app/" color="primary" target="_blank" class="mb-2" small block outlined>
        Probar beta
      </v-btn>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MenuOptions",
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters(["getMenuOptions"]),
  },
  mounted() {
    this.verifyScreenSize();
  },
  methods: {
    verifyScreenSize() {
      this.show = window.innerWidth >= 960;
    },
  },
};
</script>
<style scoped>
.v-list-item--link:before {
  background-color: var(--primary-color) !important;
  border-radius: 16px 0 0 16px;
}
.v-list .v-list-item--active {
  border-right: 4px solid var(--primary-color);
}
.v-list .v-list-item--active .v-list-item__title {
  font-weight: bold;
}
.v-list .v-list-item--active,
.v-list .v-list-item--active .v-icon {
  color: var(--primary-color) !important;
}
</style>
<style>
#menu-options .v-list-group .v-list-group__items {
  margin-left: 52px !important;
  border-left: 1px solid #a8a8a8 !important;
}

#menu-sub-options .v-list-group .v-list-group__items {
  margin-left: 52px !important;
  border-left: 1px solid #a8a8a8 !important;
}

#menu-sub-options .v-list-group__header {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

#menu-sub-options .v-list-group .v-list-group__items .v-list-item {
  padding-left: 10px !important;
}

#menu-sub-options.v-list {
  width: 100% !important;
}

#items-sub-options {
  padding-right: 0 !important;
}

#menu-sub-options .v-list-group .v-list-group__items {
  margin-left: 30px !important;
}

.v-list-item__content > #menu-sub-options {
  padding: 0 !important;
}
</style>
